import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, BookOpen, Wallet, GraduationCap, Banknote } from "lucide-react";
import { api, egp } from "@/lib/api";
import { ACard, AH1 } from "./ui";

export default function AdminOverview() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  const cards = s ? [
    [Users, "الطلاب", s.students, "stat-students"],
    [BookOpen, "الكورسات (المنشورة)", `${s.courses} (${s.published_courses})`, "stat-courses"],
    [GraduationCap, "اشتراكات مفعّلة", s.enrollments, "stat-enrollments"],
    [Wallet, "طلبات دفع معلقة", s.pending_payments, "stat-pending-payments"],
    [Banknote, "إجمالي الإيرادات المعتمدة", egp(s.revenue), "stat-revenue"],
  ] : [];
  return (
    <div data-testid="admin-overview">
      <AH1>نظرة عامة</AH1>
      <div className="grid sm:grid-cols-2 xl:grid-cols-5 gap-4">
        {cards.map(([Icon, l, v, id]) => (
          <ACard key={id}>
            <Icon className="text-[var(--kh-violet-2)] mb-3" size={22} />
            <p className="text-xs text-slate-400">{l}</p>
            <p className="font-display text-3xl mt-1" data-testid={id}>{v}</p>
          </ACard>
        ))}
      </div>
      {s?.pending_payments > 0 && (
        <ACard className="mt-6 flex items-center justify-between border-yellow-400/20">
          <p className="text-yellow-200">عندك {s.pending_payments} طلب دفع محتاج مراجعة.</p>
          <Link to="/admin/payments" className="text-sm text-[var(--kh-violet-2)] hover:underline" data-testid="overview-review-payments">راجع الطلبات</Link>
        </ACard>
      )}
    </div>
  );
}
